function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as d3 from 'd3';
import React, { Component } from 'react';
import BarChart from './BarChart';
import PropTypes from 'prop-types';
import dc from 'dc';
/**
 * Renders an ordinal barchart
 */

export var BarChartOrdinal = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BarChartOrdinal, _Component);

  function BarChartOrdinal() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BarChartOrdinal.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(BarChart, _extends({
      id: this.props.id,
      x: d3.scaleBand(),
      xUnits: dc.units.ordinal
      /*
      barPadding={0.1}
      outerPadding={0.05}
      */

    }, this.props));
  };

  return BarChartOrdinal;
}(Component);

_defineProperty(BarChartOrdinal, "defaultProps", {
  chartTitle: ''
});

BarChartOrdinal.propTypes = process.env.NODE_ENV !== "production" ? {
  chartTitle: PropTypes.string,
  group: PropTypes.object.isRequired,
  dimension: PropTypes.object.isRequired
} : {};
export default BarChartOrdinal;